import type { DocMigration } from "../docMigration";

function editRelativeVerticalDatum(verticalDatum) {
  const topDatumId = verticalDatum.topDatumId;

  if (topDatumId && topDatumId === "BOTTOM_OF_WALL_PLATE_HOST") {
    verticalDatum.topDatumId = "TOP_OF_WALL_PLATE_HOST";
  }
  if (topDatumId && topDatumId === "BOTTOM_OF_FF_HOST") {
    verticalDatum.topDatumId = "TOP_OF_WALL_PLATE_BELOW_HOST";
  }
  const bottomDatumId = verticalDatum.topDatumId;
  if (bottomDatumId && bottomDatumId === "BOTTOM_OF_WALL_PLATE_HOST") {
    verticalDatum.bottomDatumId = "TOP_OF_WALL_PLATE_HOST";
  }
  if (bottomDatumId && bottomDatumId === "BOTTOM_OF_FF_HOST") {
    verticalDatum.bottomDatumId = "TOP_OF_WALL_PLATE_BELOW_HOST";
  }

  return verticalDatum;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_260: DocMigration = {
  maxSchemaVersion: "0.0.260",
  description: "Eliminate a redundant vertical datum and change enum name",
  apply(json: any) {
    if (json.settings) {
      for (const settingId in json.settings) {
        const setting = json.settings[settingId];
        if (setting.type === "COLUMN_CATALOG_SETTINGS") {
          const columnTable = setting.columnTable;
          for (const columnId in columnTable) {
            const column = columnTable[columnId];
            if (column.subType === "STRUCTURAL") {
              const verticalDatum = column.verticalDatum;
              if (verticalDatum && verticalDatum.type === "RELATIVE") {
                editRelativeVerticalDatum(verticalDatum);
              }
            }
          }
        }
      }
    }
    if (json.columns) {
      const allColumnIds = Object.keys(json.columns);
      for (const columnId of allColumnIds) {
        const column = json.columns[columnId];
        const verticalDatum = column.verticalDatum;
        if (verticalDatum && verticalDatum.type === "RELATIVE") {
          editRelativeVerticalDatum(verticalDatum);
        }
      }
    }
    if (json.stairBlocks) {
      for (const stairBlockId of Object.keys(json.stairBlocks)) {
        const stairBlock = json.stairBlocks[stairBlockId];
        const foundationPatterns = stairBlock?.foundationPatterns;
        if (foundationPatterns) {
          for (const foundationPatternId in foundationPatterns) {
            const foundationPattern = foundationPatterns[foundationPatternId].foundationPattern;
            if (foundationPattern) {
              const verticalDatum = foundationPattern.verticalDatum;

              if (verticalDatum && verticalDatum.type === "RELATIVE") {
                editRelativeVerticalDatum(verticalDatum);
              }
            }
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_260;
